import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import './Dropdown.styles.less';

class Dropdown extends React.Component {
  state = {
    isListVisible: false,
  };

  toggleVisibility = () => {
    if (this.state.isListVisible) {
      document.removeEventListener('click', this.toggleVisibility);
    } else {
      document.addEventListener('click', this.toggleVisibility);
    }

    this.setState(prevState => ({ isListVisible: !prevState.isListVisible }));
  };

  render() {
    const { list, selected, onChangeSelected } = this.props;
    const { isListVisible } = this.state;
    const hasMoreThanOneItem = list.length > 1;
    const navClasses = cx('sc__dropdown__nav', { 'sc__dropdown__nav--cursor': hasMoreThanOneItem });

    return (
      <div className="sc__dropdown">
        <div className={navClasses} onClick={this.toggleVisibility}>
          <span className="sc__dropdown__nav__label">{selected.name}</span>
          {hasMoreThanOneItem && <span className="sc__dropdown__nav__icon" />}
        </div>

        {isListVisible && hasMoreThanOneItem && (
          <div className="sc__dropdown__content">
            <ul className="sc__dropdown__list">
              {list.map((item, i) => (
                <li
                  key={`${i}-${item.name}`}
                  className="sc__dropdown__list-item"
                  onClick={() => onChangeSelected(item)}
                >
                  <span className="sc__dropdown__list-item__label">{item.name}</span>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    );
  }
}

Dropdown.propTypes = {
  list: PropTypes.arrayOf(PropTypes.shape({})),
  selected: PropTypes.shape({
    name: PropTypes.string,
  }),
  onChangeSelected: PropTypes.func,
};

export default Dropdown;



// WEBPACK FOOTER //
// ./src/components/manage/seatingchart/Header/Dropdown/Dropdown.jsx